@if (entry() && position(); as pos) {
  <div class="bb-gloss-overlay"
       role="tooltip"
       [style.left.px]="pos.left"
       [style.top.px]="pos.top">
    <header class="bb-gloss-overlay__header">
      <span class="bb-gloss-overlay__token">{{ token() }}</span>
      <span class="bb-gloss-overlay__term">{{ entry()!.term }}</span>
    </header>
    <p class="bb-gloss-overlay__def">{{ entry()!.definition }}</p>
    @if (entry()!.seeAlso?.length) {
      <p class="bb-gloss-overlay__see">
        See also:
        @for (sa of entry()!.seeAlso!; track sa) {
          <span class="bb-gloss-overlay__see-item">{{ sa }}</span>
        }
      </p>
    }
  </div>
}
